import { calcBusinessTax, calcSaleAmt, InvoiceParser } from '@yosgo/swapjs'
import React, { useEffect, useRef, useState } from 'react'
const Barcode = require('react-barcode')
import QRCode from 'qrcode.react'
import { Link, SWAPLogo } from '@yosgo/swap-ui'
import { makeStyles } from '@material-ui/core'
import EditIconButton from '../Edit/EditIconButton'

const useStyles = makeStyles(() => ({
  editmode: {
    cursor: 'pointer',
    borderRadius: 4,
    position: 'relative',
    '&:hover': {
      backgroundColor: '#cccccc4d',
    },
  },
}))

/*　HTML to JSX Compiler : https://magic.reactjs.net/htmltojsx.htm */
const htmlStyle =
  '.root { background-color: white; width: 595px;  height: 100%;  background-image: url("https://logan-playground.s3.ap-northeast-1.amazonaws.com/logowaterprint.png");  background-repeat: no-repeat;  background-size: 494px 494px;  background-position: center;}.head {  height: 128px;  width: 100%;  background-color: #4862cc;  color: white;  display: flex;  display: -webkit-flex;  justify-content: space-between;  -webkit-justify-content: space-between;}.leftblock {  margin: 32px 0 0 30px;}.title1 {  font-size: 18px;  font-weight: 700;  line-height: 25.2px;}.title2 {  font-size: 18px;  font-weight: 900;  line-height: 22.5px;}.createat {  margin-top: 5px;  font-weight: 700;}.rightblock {  margin: 78px 30px 0 0;  text-align: right;}.link {  font-weight: 700;  line-height: 11.2px;  color: #ffffff;  text-decoration: none;cursor: pointer;}.rightblock:hover {  text-decoration: underline;}.body {  width: 100%;  height: 1fr;}.declarationtitle {  font-weight: 700;  line-height: 14px;  margin-left: 2px;  margin-right: 8px;  white-space: nowrap;}.declaration {  width: 437px;  line-height: 1.4;  word-break: break-all;}.bluetitle {  font-size: 16px;  font-weight: 700;  line-height: 22.4px;  color: #4862cc;}.subtitle {  font-weight: 700;}.content {  margin-bottom: 4px;}.signature {  width: 173px;  height: 96px;  border: 1px solid #cccccc;  box-sizing: border-box;  position: relative; font-weight: 700;  color: #909090;}.invoice {  width: 160px;  height: fit-content;padding-bottom:12px;  border: 1px solid #000000;  background-color: #ffffff;  white-space: nowrap;  display: flex;  display: -webkit-flex;  justify-content: center;  -webkit-justify-content: center;  }.barcode {  height: 30px;  width: 100%;  margin-top: 6px;}.qrcode {  height: 62px;  width: 62px;}.normalchip {width: 64px; height: 24px; display: -webkit-flex; justify-content: center; -webkit-justify-content: center; align-items: center; -webkit-align-items: center; border: 1px solid #cccccc; color: #4b4b4b; border-radius: 4px;  font-weight: 700; line-height: 16.8px;}.greenchip {width: 72px;height: 24px;display: flex;display: -webkit-flex;justify-content: center;-webkit-justify-content: center;align-items: center;-webkit-align-items: center;border: 1px solid #00821e;color: #00821e;border-radius: 4px;font-weight: 700;line-height: 16.8px;}.flex {  display: flex;  display: -webkit-flex;}.spacebetween {  justify-content: space-between;  -webkit-justify-content: space-between;}.aligncenter {  align-items: center;  -webkit-align-items: center;}.line {  margin: 4px 0 8px 0;  width: 100%;  height: 1px;  background-color: #000000;}.fontsize {display:flex;align-items: center }'
const fileType = '請款單'

interface TemplateProps {
  createAt: React.ReactNode
  status: number
  memberName: React.ReactNode
  memberPhone: React.ReactNode
  memberEmail: React.ReactNode
  cName: React.ReactNode
  cPhone: React.ReactNode
  cCompanyName: React.ReactNode
  cTaxid: React.ReactNode
  cEmail: React.ReactNode
  virtualAccount: React.ReactNode
  taxAmount: React.ReactNode
  description: React.ReactNode
  comment: React.ReactNode
  isInvoiceMode: boolean
  invoiceInfo: string
  cSignature: React.ReactNode
  sSignaturedAt: string
  sSignature: React.ReactNode
  seal: React.ReactNode
  taxAmountWithEditButton: React.ReactNode
  isMobile?: boolean
  isEditMode?: boolean
  canDataEditable?: boolean
  setIsOpenEditCustomerInfoModal?: (isOpen: boolean) => void
  setIsOpenEditPaymentAmountModal?: (isOpen: boolean) => void
  setIsOpenEditCommentModal?: (isOpen: boolean) => void
  setStep?: (step: number) => void
  personalId: string
  setIsDescriptionTwoLines?: (isTwoLines: boolean) => void
}

const Template = ({
  createAt,
  status,
  memberName,
  memberPhone,
  memberEmail,
  cName,
  cPhone,
  cCompanyName,
  cTaxid,
  cEmail,
  virtualAccount,
  taxAmount,
  description,
  comment,
  isInvoiceMode,
  invoiceInfo,
  cSignature,
  sSignaturedAt,
  sSignature,
  seal,
  taxAmountWithEditButton,
  isMobile,
  isEditMode,
  canDataEditable,
  setIsOpenEditPaymentAmountModal,
  setIsOpenEditCustomerInfoModal,
  setIsOpenEditCommentModal,
  setStep,
  personalId,
  setIsDescriptionTwoLines,
}: TemplateProps) => {
  const [isMobileDevice, setIsMobileDevice] = useState(false)

  useEffect(() => {
    if (window) {
      const matched =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          window.navigator.userAgent
        ) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
      setIsMobileDevice(matched)
    }
  }, [])

  const parseInvoiceInfo: any = invoiceInfo
    ? new InvoiceParser(invoiceInfo)
    : null

  const fontsize9 = {
    fontSize: isMobile && isMobileDevice ? 8 : 12,
    zoom: isMobile && isMobileDevice ? 9 / 8 : 0.75,
  }
  const fontsize8 = {
    fontSize: isMobile && isMobileDevice ? 8 : 12,
    zoom: isMobile && isMobileDevice ? 1 : 0.6666666666,
  }
  const fontsize7 = {
    fontSize: isMobile && isMobileDevice ? 7 : 12,
    zoom: isMobile && isMobileDevice ? 1 : 0.58333333333,
  }
  const invoicefontsize = {
    fontWeight: 300,
    fontSize: isMobile && isMobileDevice ? 7.2 : 12,
    zoom: isMobile && isMobileDevice ? 1 : 0.6,
  }

  const classes = useStyles()
  const ref = useRef(null)
  useEffect(() => {
    const r: any = ref.current
    if (r && setIsDescriptionTwoLines) {
      if (r.clientHeight > 20) {
        setIsDescriptionTwoLines(true)
      } else {
        setIsDescriptionTwoLines(false)
      }
    }
  }, [description, ref])

  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: htmlStyle,
        }}
      />
      <div className="root" style={{ border: '1px solid #cccccc' }}>
        <div className="head">
          <div className="leftblock">
            {swaplogo_white}
            <div className="flex aligncenter">
              <div className="title1" style={{ marginRight: '4px' }}>
                請款單
              </div>
              <div className="title2 ">INVOICE</div>
            </div>
            <div className="createat">
              <div
                style={{ ...fontsize7, display: 'flex', alignItems: 'center' }}
              >
                建立日期：
                <span>{createAt}</span>
              </div>
            </div>
          </div>
          <div className="rightblock">
            <div
              className="link"
              onClick={() => window.open('https://swap.work')}
            >
              <div style={fontsize8}>www.swap.work</div>
            </div>
            <div
              className="link"
              onClick={() => window.open('https://swap.work')}
            >
              <div style={fontsize8}>自由工作者的財務管理平台</div>
            </div>
          </div>
        </div>
        <div className="body">
          <div style={{ padding: '16px 30px' }}>
            <div className="flex spacebetween">
              <div className="flex aligncenter" style={{ width: '98px' }}>
                {swaplogo_black}
                <div className="declarationtitle">
                  <div
                    style={{
                      fontSize: isMobile && isMobileDevice ? 8 : 12,
                      zoom:
                        isMobile && isMobileDevice ? 10 / 8 : 0.8333333333333,
                    }}
                  >
                    平台聲明
                  </div>
                </div>
              </div>
              <div className="declaration">
                <div style={fontsize8}>
                  SWAP 平台(優市股份有限公司)
                  ，以下簡稱本公司，本公司致力於提供各式接案所需的平台服務，以節省會員與客戶間行政往來的作業時間，讓雙方更專注於合作過程與產出。本
                  {fileType}
                  僅供行政手續使用，本公司不介入勞務服務的內容以及履行成果，當您簽署本
                  {fileType}時即同意 SWAP 平台的網站服務條款
                  <a
                    href="https://swap.work/terms"
                    target="_blank"
                    style={{ color: '#1747c2' }}
                  >
                    www.swap.work/terms
                  </a>
                  。
                </div>
              </div>
            </div>
            <div className="flex spacebetween" style={{ marginTop: '16px' }}>
              <div className="bluetitle">聯絡資訊</div>
              <div
                className={status !== 2 ? 'normalchip' : 'greenchip'}
                style={{
                  width:
                    status !== 2 && isInvoiceMode && parseInvoiceInfo
                      ? 120
                      : undefined,
                }}
              >
                <span
                  style={{
                    fontSize: isMobile && isMobileDevice ? 8 : 12,
                    zoom: isMobile && isMobileDevice ? 1.5 : 1,
                  }}
                >
                  {status !== 2
                    ? isInvoiceMode && parseInvoiceInfo
                      ? '有發票，尚未付款'
                      : '尚未付款'
                    : '已付款'}
                </span>
                {status === 2 ? icon_checked : null}
              </div>
            </div>
            <div className="flex spacebetween">
              <div style={{ marginTop: '2px' }}>
                <div className="flex spacebetween" style={{ width: '357px' }}>
                  <div style={{ width: '167px', marginTop: 8 }}>
                    <div className="subtitle fontsize" style={fontsize9}>
                      平台會員
                    </div>
                    <div className="line" />
                    <div className="content">
                      <div className="fontsize" style={fontsize9}>
                        會員姓名：{memberName}
                      </div>
                    </div>
                    <div className="content">
                      <div className="fontsize" style={fontsize9}>
                        會員電話：{memberPhone}
                      </div>
                    </div>
                    <div className="content">
                      <div className="fontsize" style={fontsize9}>
                        會員信箱：{memberEmail}
                      </div>
                    </div>
                    <div className="content">
                      <div style={{ display: 'flex', ...fontsize9 }}>
                        <span style={{ whiteSpace: 'nowrap' }}>會員網址：</span>
                        <Link
                          target="_blank"
                          href={`https://swap.work/profile/${personalId}`}
                          style={{
                            fontWeight: 400,
                            textDecoration: 'underline',
                            wordBreak: 'break-all',
                          }}
                        >
                          swap.work/profile/{personalId}
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{ width: '175px', padding: 8 }}
                    className={
                      isEditMode && canDataEditable
                        ? classes.editmode
                        : undefined
                    }
                    onClick={() => {
                      if (
                        setIsOpenEditCustomerInfoModal &&
                        isEditMode &&
                        canDataEditable
                      ) {
                        setIsOpenEditCustomerInfoModal(true)
                      }
                    }}
                  >
                    {isEditMode && canDataEditable && (
                      <div
                        style={{
                          position: 'absolute',
                          right: 12,
                          bottom: 12,
                          ...fontsize9,
                        }}
                      >
                        <EditIconButton
                          onClick={() => {
                            if (setIsOpenEditCustomerInfoModal) {
                              setIsOpenEditCustomerInfoModal(true)
                            }
                          }}
                        />
                      </div>
                    )}
                    <div className="subtitle fontsize" style={fontsize9}>
                      合作客戶
                    </div>
                    <div className="line" />
                    <div className="content">
                      <div className="fontsize" style={fontsize9}>
                        客戶姓名：{cName}
                      </div>
                    </div>
                    <div className="content">
                      <div className="fontsize" style={fontsize9}>
                        客戶電話：{cPhone}
                      </div>
                    </div>
                    <div className="content">
                      <div className="fontsize" style={fontsize9}>
                        公司名稱：{cCompanyName}
                      </div>
                    </div>
                    <div className="content">
                      <div className="fontsize" style={fontsize9}>
                        統一編號：{cTaxid}
                      </div>
                    </div>
                    <div className="content">
                      <div className="fontsize" style={fontsize9}>
                        客戶信箱：{cEmail}
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ width: '349px', marginTop: '8px' }}>
                  <div className="subtitle fontsize" style={fontsize9}>
                    平台方
                  </div>
                  <div className="line" />
                  <div className="flex spacebetween">
                    <div className="content" style={{ width: '167px' }}>
                      <div className="fontsize" style={fontsize9}>
                        公司名稱：優市股份有限公司
                      </div>
                    </div>
                    <div className="content" style={{ width: '167px' }}>
                      <div className="fontsize" style={fontsize9}>
                        統一編號：52601428
                      </div>
                    </div>
                  </div>
                  <div className="content">
                    <div className="fontsize" style={fontsize9}>
                      公司信箱：swap@yosgo.com
                    </div>
                  </div>
                </div>
                <div className="bluetitle" style={{ margin: '12px 0 8px 0' }}>
                  請款資訊
                </div>
                <div ref={ref} className="content">
                  <div
                    className={
                      isEditMode && canDataEditable
                        ? classes.editmode
                        : undefined
                    }
                    onClick={() => {
                      if (
                        setIsOpenEditPaymentAmountModal &&
                        isEditMode &&
                        canDataEditable
                      ) {
                        if (setStep) {
                          setStep(1)
                        }
                        setIsOpenEditPaymentAmountModal(true)
                      }
                    }}
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      ...fontsize9,
                      padding: 2,
                      width: 'calc(100% - 24px)',
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {isEditMode && canDataEditable && (
                        <div style={{ marginRight: 6 }}>
                          <EditIconButton
                            width={20}
                            height={20}
                            onClick={() => {
                              if (setIsOpenEditPaymentAmountModal) {
                                if (setStep) {
                                  setStep(1)
                                }
                                setIsOpenEditPaymentAmountModal(true)
                              }
                            }}
                          />
                        </div>
                      )}
                      <div style={{ whiteSpace: 'nowrap' }}>勞務服務內容：</div>
                    </div>
                    <div style={{ marginRight: 24, wordBreak: 'break-all' }}>
                      {description}
                    </div>
                  </div>
                </div>
                <div
                  className={isEditMode ? classes.editmode : undefined}
                  onClick={() => {
                    if (setIsOpenEditPaymentAmountModal && isEditMode) {
                      if (setStep) {
                        setStep(2)
                      }
                      setIsOpenEditPaymentAmountModal(true)
                    }
                  }}
                  style={{
                    padding: 2,
                    marginRight: 24,
                    display: 'flex',
                    alignItems: 'flex-start',
                    ...fontsize9,
                    marginBottom: 4,
                    width: 'calc(100% - 24px)',
                  }}
                >
                  {isEditMode && (
                    <div style={{ marginRight: 6 }}>
                      <EditIconButton
                        width={20}
                        height={20}
                        onClick={() => {
                          if (setIsOpenEditPaymentAmountModal) {
                            if (setStep) {
                              setStep(2)
                            }
                            setIsOpenEditPaymentAmountModal(true)
                          }
                        }}
                      />
                    </div>
                  )}
                  <span>請款金額：</span>
                  {taxAmountWithEditButton}
                </div>
                <div
                  className={isEditMode ? classes.editmode : undefined}
                  onClick={() => {
                    if (setIsOpenEditCommentModal && isEditMode) {
                      setIsOpenEditCommentModal(true)
                    }
                  }}
                  style={{
                    padding: 2,
                    marginRight: 24,
                    display: 'flex',
                    alignItems: 'flex-start',
                    ...fontsize9,
                    marginBottom: 4,
                    width: 'calc(100% - 24px)',
                  }}
                >
                  {isEditMode && (
                    <div style={{ marginRight: 6 }}>
                      <EditIconButton
                        width={20}
                        height={20}
                        onClick={() => {
                          if (setIsOpenEditCommentModal) {
                            setIsOpenEditCommentModal(true)
                          }
                        }}
                      />
                    </div>
                  )}
                  <div style={{ whiteSpace: 'nowrap' }}>請款單備註：</div>
                  {comment}
                </div>
                <div className="content" style={{ marginTop: '16px' }}>
                  <div className="fontsize" style={fontsize9}>
                    銀行戶名：優市股份有限公司
                  </div>
                </div>
                <div className="content">
                  <div className="fontsize" style={fontsize9}>
                    銀行/分行：國泰世華 華山分行 013-1184
                  </div>
                </div>
                <div className="content">
                  <div className="fontsize" style={fontsize9}>
                    匯款虛擬帳號：{virtualAccount}
                  </div>
                </div>
                <div
                  className="fontsize content flex"
                  style={{ alignItems: 'flex-start', ...fontsize9 }}
                >
                  匯款金額：{taxAmount ? taxAmount : '- 元（含稅）'}
                </div>
                <div
                  className="content"
                  style={{
                    marginTop: '24px',
                    marginRight: 24,
                    wordBreak: 'break-all',
                  }}
                >
                  <div style={fontsize9}>
                    ※
                    匯款帳號為優市股份有限公司於國泰世華銀行所設定，專屬於此請款單付款之虛擬帳號，僅限
                    <b>一次性收款</b>，銀行系統將驗證金額是否為{' '}
                    {taxAmount ? taxAmount : ' -元（含稅）'}
                    ，若金額不符合，將導致交易失敗或是退匯。匯款時請留意手續費與金額。
                  </div>
                </div>
                {isInvoiceMode && (
                  <div
                    className="content"
                    style={{ marginRight: 24, wordBreak: 'break-all' }}
                  >
                    <div className="fontsize" style={fontsize9}>
                      ※ 本請款單為先開發票後付款，請於發票開立後 30
                      日內完成匯款。若逾期付款 SWAP 平台得作廢發票。
                    </div>
                  </div>
                )}
              </div>
              <div
                style={{
                  position: 'relative',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                {!invoiceInfo && (
                  <div
                    style={{
                      width: 161,
                      height: 58,
                      position: 'absolute',
                      backgroundColor: '#E6E9F8',
                      border: '1px solid #97A3E1',
                      borderRadius: 8,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      zIndex: 1,
                      zoom: 0.85,
                      top: 245,
                      padding: '0 12px',
                    }}
                  >
                    {icon_noinvoice}
                    <div
                      style={{
                        width: 97,
                        wordBreak: 'break-all',
                        marginLeft: 8,
                        fontSize: isMobile && isMobileDevice ? 8 : 12,
                        zoom: isMobile && isMobileDevice ? 12 / 8 : 1,
                      }}
                    >
                      發票將於客戶完成匯款後自動開立
                    </div>
                  </div>
                )}
                <div
                  className="invoice"
                  style={{
                    marginTop: '22px',
                    opacity: !invoiceInfo ? 0.5 : 1,
                  }}
                >
                  <div style={{ margin: '0 10px' }}>
                    <div
                      style={{
                        margin: '10px 0 4px',
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <SWAPLogo black />
                    </div>
                    <div
                      style={{
                        fontSize: '0.96rem',
                        textAlign: 'center',
                      }}
                    >
                      優市股份有限公司
                    </div>
                    <div style={{ fontSize: '1.17rem', textAlign: 'center' }}>
                      電子發票證明聯
                    </div>
                    <div style={{ fontSize: '1.12rem', textAlign: 'center' }}>
                      <span>
                        {parseInvoiceInfo ? parseInvoiceInfo.year : ''}
                      </span>
                      <span>年</span>
                      <span>
                        {parseInvoiceInfo
                          ? `${parseInvoiceInfo.month.left}－
                        ${parseInvoiceInfo.month.right}`
                          : ''}
                      </span>
                      <span>月</span>
                    </div>
                    <div style={{ fontSize: '1.07rem', textAlign: 'center' }}>
                      {parseInvoiceInfo ? parseInvoiceInfo.InvoiceNumber : ''}
                    </div>
                    <div className="flex spacebetween">
                      <div style={invoicefontsize}>
                        {parseInvoiceInfo ? parseInvoiceInfo.CreateTime : ''}
                      </div>
                      <div style={invoicefontsize}>
                        格式<span>25</span>
                      </div>
                    </div>
                    <div className="flex spacebetween">
                      <div style={invoicefontsize}>
                        隨機碼：
                        <span>
                          {parseInvoiceInfo ? parseInvoiceInfo.RandomNum : ''}
                        </span>
                      </div>
                      <div style={invoicefontsize}>
                        總計
                        <span>
                          {parseInvoiceInfo
                            ? parseInvoiceInfo.TotalAmt.toLocaleString()
                            : ''}
                        </span>
                      </div>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <div
                        style={{
                          ...invoicefontsize,
                        }}
                      >
                        賣方：52601428
                      </div>
                      <div
                        style={{
                          ...invoicefontsize,
                          wordBreak: 'break-all',
                          whiteSpace: 'normal',
                        }}
                      >
                        買方：{cTaxid}
                      </div>
                    </div>
                    {parseInvoiceInfo ? (
                      <div style={{ position: 'relative', marginBottom: 50 }}>
                        <div
                          style={{
                            position: 'absolute',
                            left: -10,
                            top: 0,
                          }}
                        >
                          <Barcode
                            width={0.74}
                            height={30}
                            displayValue={false}
                            value={parseInvoiceInfo.BarCode}
                          />
                        </div>
                      </div>
                    ) : (
                      <div
                        style={{
                          width: '100%',
                          height: 30,
                          border: '1px solid #000000',
                          marginTop: '6px',
                        }}
                      />
                    )}
                    <div
                      className="flex spacebetween"
                      style={{ margin: '8px 0 12px 0' }}
                    >
                      {parseInvoiceInfo ? (
                        <>
                          <QRCode size={60} value={parseInvoiceInfo.QRcodeL} />
                          <QRCode size={60} value={parseInvoiceInfo.QRcodeR} />
                        </>
                      ) : (
                        <>
                          <div
                            style={{
                              height: 62,
                              width: 62,
                              border: '1px solid #000000',
                            }}
                          />
                          <div
                            style={{
                              height: 62,
                              width: 62,
                              border: '1px solid #000000',
                            }}
                          />
                        </>
                      )}
                    </div>
                    <div className="flex spacebetween">
                      <div
                        style={{
                          ...fontsize7,
                          textAlign: 'left',
                        }}
                      >
                        [品名/單價]
                      </div>
                      <div
                        style={{
                          ...fontsize7,
                          textAlign: 'left',
                        }}
                      >
                        [數量]
                      </div>
                      <div
                        style={{
                          ...fontsize7,
                          textAlign: 'right',
                        }}
                      >
                        [金額]
                      </div>
                    </div>
                    <div
                      style={{
                        textAlign: 'left',
                        ...fontsize7,
                      }}
                    >
                      勞務服務費
                    </div>
                    <div
                      className="flex spacebetween"
                      style={{ marginBottom: '4px' }}
                    >
                      <div
                        style={{
                          ...fontsize7,
                          textAlign: 'left',
                        }}
                      >
                        {parseInvoiceInfo
                          ? calcSaleAmt(
                              parseInvoiceInfo.TotalAmt
                            ).toLocaleString()
                          : ''}
                      </div>
                      <div
                        style={{
                          ...fontsize7,
                          textAlign: 'left',
                        }}
                      >
                        1
                      </div>
                      <div
                        style={{
                          ...fontsize7,
                          textAlign: 'right',
                        }}
                      >
                        {parseInvoiceInfo
                          ? calcSaleAmt(
                              parseInvoiceInfo.TotalAmt
                            ).toLocaleString() + ' TX'
                          : ''}
                      </div>
                    </div>
                    <div style={{ textAlign: 'left', marginBottom: '4px' }}>
                      <div style={fontsize7}>
                        銷售額(應稅)：
                        <span>
                          {parseInvoiceInfo
                            ? calcSaleAmt(
                                parseInvoiceInfo.TotalAmt
                              ).toLocaleString()
                            : ''}
                        </span>
                        元
                      </div>
                    </div>
                    <div style={{ textAlign: 'left', marginBottom: '4px' }}>
                      <div style={fontsize7}>
                        稅額：
                        <span>
                          {parseInvoiceInfo
                            ? calcBusinessTax(
                                parseInvoiceInfo.TotalAmt
                              ).toLocaleString()
                            : ''}
                        </span>
                        元
                      </div>
                    </div>
                    <div style={{ textAlign: 'left', marginBottom: '4px' }}>
                      <div style={fontsize7}>
                        總計：
                        <span>
                          {parseInvoiceInfo
                            ? parseInvoiceInfo.TotalAmt.toLocaleString()
                            : ''}
                        </span>
                        元
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bluetitle" style={{ margin: '33px 0 8px 0' }}>
              簽章
            </div>
            <div className="flex spacebetween">
              {cSignature}
              {sSignature}
              <div className="signature">
                <div
                  style={{
                    position: 'absolute',
                    top: '6px',
                    textAlign: 'center',
                    width: '100%',
                  }}
                >
                  <div style={fontsize8}>SWAP 平台簽章</div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: 'calc(100% - 30px)',
                    marginTop: 17,
                    pointerEvents: 'none',
                  }}
                >
                  {seal}
                </div>
                <div
                  style={{
                    position: 'absolute',
                    bottom: '6.5px',
                    left: '8px',
                  }}
                >
                  <div style={fontsize8}>
                    簽署日期：
                    <span style={{ color: '#4b4b4b' }}>{sSignaturedAt}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const icon_noinvoice = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 9H11V7H13V9ZM13 17H11V11H13V17ZM12 2C10.6868 2 9.38642 2.25866 8.17317 2.7612C6.95991 3.26375 5.85752 4.00035 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C5.85752 19.9997 6.95991 20.7362 8.17317 21.2388C9.38642 21.7413 10.6868 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2Z"
      fill="#4862CC"
    />
  </svg>
)

const swaplogo_white = (
  <svg
    width={55}
    height={27}
    viewBox="0 0 55 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1153 13.9837C12.0659 13.6417 11.9916 13.3124 11.9174 12.9704C11.7814 12.375 11.633 11.7924 11.4598 11.2224C11.3238 10.7664 11.1877 10.323 11.0517 9.87969C10.9527 9.56303 10.8414 9.23369 10.7301 8.91703C10.4209 8.01769 10.087 7.11836 9.74065 6.23169C9.61696 6.30769 9.49328 6.38369 9.3696 6.47236C8.29357 7.27036 7.94727 8.41036 7.94727 9.62636C7.94727 9.96836 7.972 10.323 8.02148 10.6777C8.13279 11.4757 8.34305 12.2737 8.5533 12.983C8.63988 13.2744 8.72646 13.5784 8.8254 13.8697C8.92435 14.1864 9.03566 14.5157 9.14698 14.8324C9.6788 16.3524 10.2972 17.847 10.9156 19.329C11.7443 18.4677 12.2019 17.315 12.2514 16.0864C12.2885 15.377 12.2266 14.6804 12.1153 13.9837Z"
      fill="#F7B52C"
    />
    <path
      d="M15.801 9.09426C15.7886 8.75226 15.7392 8.41026 15.6526 8.08093C15.4052 7.11826 14.8486 6.25692 14.0571 5.64892C12.9687 4.81292 11.5587 4.53425 10.2601 4.91425C10.1982 4.92692 10.1488 4.95225 10.0869 4.96492C9.83955 5.05359 9.59219 5.15492 9.35719 5.28159C8.33064 5.83892 7.53908 6.77626 7.15566 7.90359C6.95777 8.56226 6.9083 9.25893 6.95777 9.95559C6.00543 10.2976 5.09018 10.7409 4.29862 11.3489C3.16076 12.2103 2.39393 13.4643 2.12183 14.8576C2.05999 15.1869 2.01052 15.5163 1.99815 15.8583C1.99815 15.8709 1.99815 15.8836 1.99815 15.8963C1.93631 17.7456 2.75261 19.5569 4.19968 20.6716C5.68386 21.8116 7.62565 22.1409 9.38193 21.5076C9.79008 21.3556 10.1735 21.1656 10.5445 20.9376C10.829 20.7603 11.1011 20.5449 11.3608 20.3169C12.14 19.6076 12.7337 18.7083 13.0429 17.6696C13.4263 16.3649 13.315 14.9209 13.0676 13.5783C13.4387 13.3883 13.785 13.1729 14.1066 12.9196C15.1702 12.0963 15.7763 10.7789 15.8257 9.42359C15.8134 9.29693 15.8134 9.19559 15.801 9.09426ZM12.7337 6.02892C13.6737 6.44692 14.3663 7.24492 14.6631 8.22026C13.6737 8.35959 12.6966 8.52426 11.7195 8.71426C11.4969 8.09359 11.2743 7.48559 11.0393 6.87759C10.9156 6.53559 10.7795 6.20626 10.6435 5.86426C11.3361 5.69959 12.0658 5.72492 12.7337 6.02892ZM4.52125 12.4509C5.25097 11.7923 6.15384 11.3363 7.08145 10.9943C7.11856 11.1843 7.1433 11.3869 7.19277 11.5769C7.36592 12.4256 7.58855 13.2489 7.86065 14.0723C6.31463 14.3636 4.74388 14.5663 3.17312 14.7436C3.39575 13.8569 3.85337 13.0589 4.52125 12.4509ZM5.84464 20.4689C4.31099 19.8229 3.24733 18.4043 3.02471 16.7323C2.9876 16.4156 2.97523 16.0989 2.9876 15.7823C4.71914 15.5796 6.46305 15.3643 8.16985 15.0476C8.39248 15.6683 8.62747 16.2763 8.86247 16.8843C9.27061 17.9356 9.7035 18.9616 10.1364 20.0003C8.87483 20.8236 7.25461 21.0643 5.84464 20.4689ZM12.2637 16.0863C12.2142 17.3149 11.7566 18.4676 10.9279 19.3289C10.2972 17.8469 9.69113 16.3523 9.1593 14.8323C9.04799 14.5156 8.93668 14.1863 8.83773 13.8696C8.73879 13.5783 8.65221 13.2869 8.56563 12.9829C8.35537 12.2609 8.14511 11.4756 8.0338 10.6776C7.98433 10.3229 7.95959 9.98093 7.95959 9.62626C7.95959 8.41026 8.3059 7.28292 9.38193 6.47226C9.49324 6.38359 9.61692 6.30759 9.75297 6.23159C10.0993 7.11826 10.4332 8.01759 10.7424 8.91693C10.8537 9.23359 10.965 9.56293 11.064 9.87959C11.2124 10.3229 11.3485 10.7789 11.4721 11.2223C11.6329 11.7923 11.7937 12.3749 11.9298 12.9703C12.004 13.2996 12.0658 13.6416 12.1277 13.9836C12.2266 14.6803 12.2884 15.3769 12.2637 16.0863ZM13.6613 11.9569C13.4139 12.1849 13.1418 12.3749 12.845 12.5396C12.6224 11.5769 12.3503 10.6269 12.0411 9.67693C12.9563 9.49959 13.8839 9.34759 14.8115 9.22093C14.8239 10.2469 14.4158 11.2729 13.6613 11.9569Z"
      fill="white"
    />
    <path
      d="M21.6018 19.4049C20.3402 19.4049 19.3508 19.1642 18.4974 18.4549C18.2995 18.2902 18.2995 17.9989 18.4726 17.8215L19.0663 17.2135C19.2147 17.0615 19.4497 17.0489 19.6229 17.1755C20.1794 17.5935 20.872 17.7455 21.6141 17.7455C22.7025 17.7455 23.2838 17.3275 23.2838 16.5549C23.2838 16.2129 23.1973 15.9342 22.987 15.7442C22.8015 15.5669 22.5912 15.4782 22.1583 15.4022L21.0205 15.2375C20.2165 15.1109 19.6229 14.8575 19.19 14.4395C18.7447 13.9835 18.5097 13.3502 18.5097 12.5395C18.5097 10.8169 19.7589 9.61353 21.7873 9.61353C22.9004 9.61353 23.7415 9.85419 24.4712 10.4242C24.6691 10.5762 24.6814 10.8929 24.5083 11.0702L23.9393 11.6529C23.7909 11.8049 23.5683 11.8175 23.3951 11.6909C22.8633 11.3109 22.2696 11.2602 21.7378 11.2602C20.7607 11.2602 20.2784 11.8175 20.2784 12.4762C20.2784 12.7169 20.3526 12.9829 20.5505 13.1729C20.736 13.3502 21.0452 13.5022 21.4286 13.5529L22.5417 13.7175C23.4075 13.8442 23.9393 14.0849 24.3351 14.4649C24.8422 14.9589 25.0648 15.6555 25.0648 16.5169C25.0896 18.3409 23.5683 19.4049 21.6018 19.4049Z"
      fill="white"
    />
    <path
      d="M34.5263 19.3161H33.6358C33.4502 19.3161 33.2895 19.1894 33.2276 19.0121L31.9908 14.8321C31.8671 14.4268 31.2982 14.4268 31.1745 14.8321L29.9377 19.0121C29.8882 19.1894 29.7151 19.3161 29.5295 19.3161H28.639C28.4412 19.3161 28.2804 19.1894 28.2309 18.9994L25.9428 10.2214C25.8686 9.94276 26.0788 9.67676 26.3509 9.67676H27.3899C27.5878 9.67676 27.7609 9.81609 27.798 10.0061L28.7998 14.1861C28.8988 14.6168 29.4924 14.6294 29.6161 14.1988L30.8035 9.99342C30.8529 9.80342 31.0261 9.67676 31.2116 9.67676H31.9537C32.1392 9.67676 32.3124 9.80342 32.3619 9.99342L33.5492 14.2114C33.6729 14.6421 34.2665 14.6294 34.3655 14.1988L35.3797 10.0188C35.4291 9.82876 35.6023 9.68942 35.7878 9.68942H36.8267C37.1112 9.68942 37.3091 9.95542 37.2349 10.2341L34.9344 19.0121C34.8849 19.1894 34.7242 19.3161 34.5263 19.3161Z"
      fill="white"
    />
    <path
      d="M43.6045 19.0247L43.2458 17.9101C43.184 17.7327 43.0232 17.6187 42.8377 17.6187H40.1043C39.9188 17.6187 39.758 17.7327 39.7086 17.9101L39.3375 19.0247C39.2757 19.2021 39.1149 19.3161 38.9417 19.3161H37.9152C37.6183 19.3161 37.4204 19.0121 37.5194 18.7334L40.6362 9.9554C40.698 9.77806 40.8588 9.66406 41.0319 9.66406H41.8853C42.0585 9.66406 42.2193 9.77806 42.2811 9.9554L45.4103 18.7334C45.5092 19.0121 45.3113 19.3161 45.0145 19.3161H44.0127C43.8271 19.3161 43.6664 19.2021 43.6045 19.0247ZM41.1062 13.7174L40.5125 15.4527C40.4135 15.7314 40.6238 16.0354 40.9083 16.0354H42.0585C42.343 16.0354 42.5532 15.7441 42.4666 15.4654L41.8977 13.7301C41.774 13.3374 41.2298 13.3247 41.1062 13.7174Z"
      fill="white"
    />
    <path
      d="M50.444 15.6934H49.0464C48.8114 15.6934 48.6259 15.8834 48.6259 16.1241V18.8854C48.6259 19.1261 48.4404 19.3161 48.2054 19.3161H47.2159C46.9809 19.3161 46.7954 19.1261 46.7954 18.8854V10.1074C46.7954 9.86676 46.9809 9.67676 47.2159 9.67676H50.444C52.3858 9.67676 53.5484 11.0448 53.5484 12.6788C53.5484 14.3254 52.3858 15.6934 50.444 15.6934ZM50.3451 11.3488H49.0464C48.8114 11.3488 48.6259 11.5388 48.6259 11.7794V13.5528C48.6259 13.7934 48.8114 13.9834 49.0464 13.9834H50.3451C51.1737 13.9834 51.7056 13.4514 51.7056 12.6661C51.7056 11.8934 51.1737 11.3488 50.3451 11.3488Z"
      fill="white"
    />
  </svg>
)

const swaplogo_black = (
  <svg
    width={48}
    height={24}
    viewBox="0 0 48 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width={48}
      height="22.3448"
      transform="translate(0 0.912109)"
      fill="white"
    />
    <path
      d="M10.0868 12.4739C10.0428 12.1699 9.97684 11.8772 9.91088 11.5732C9.78994 11.044 9.65802 10.5261 9.5041 10.0194C9.38317 9.61407 9.26224 9.22 9.1413 8.82592C9.05335 8.54444 8.95441 8.2517 8.85546 7.97022C8.58062 7.17081 8.28378 6.3714 7.97595 5.58325C7.86601 5.65081 7.75607 5.71836 7.64613 5.79718C6.68967 6.50651 6.38184 7.51985 6.38184 8.60074C6.38184 8.90474 6.40382 9.22 6.4478 9.53525C6.54675 10.2446 6.73364 10.9539 6.92054 11.5844C6.99749 11.8434 7.07445 12.1136 7.1624 12.3726C7.25035 12.6541 7.3493 12.9468 7.44824 13.2283C7.92098 14.5794 8.47068 15.908 9.02037 17.2253C9.75696 16.4597 10.1637 15.4351 10.2077 14.343C10.2407 13.7124 10.1857 13.0932 10.0868 12.4739Z"
      fill="#CCCCCC"
    />
    <path
      d="M13.3629 8.12787C13.3519 7.82387 13.308 7.51987 13.231 7.22713C13.0111 6.37142 12.5164 5.60579 11.8128 5.06535C10.8453 4.32223 9.59202 4.07453 8.43766 4.41231C8.38269 4.42357 8.33871 4.44608 8.28374 4.45734C8.06387 4.53616 7.84399 4.62623 7.6351 4.73883C6.72261 5.23423 6.019 6.06742 5.67819 7.0695C5.50229 7.65498 5.45831 8.27424 5.50229 8.8935C4.65576 9.1975 3.84221 9.59157 3.1386 10.132C2.12716 10.8976 1.44554 12.0123 1.20367 13.2508C1.1487 13.5436 1.10473 13.8363 1.09373 14.1403C1.09373 14.1516 1.09373 14.1628 1.09373 14.1741C1.03876 15.8179 1.76436 17.428 3.05065 18.4188C4.36992 19.4322 6.09596 19.7249 7.65709 19.162C8.01989 19.0268 8.3607 18.858 8.69052 18.6553C8.94338 18.4977 9.18524 18.3062 9.41612 18.1036C10.1087 17.4731 10.6364 16.6737 10.9113 15.7504C11.2521 14.5907 11.1532 13.3071 10.9333 12.1136C11.2631 11.9448 11.5709 11.7534 11.8568 11.5282C12.8022 10.7963 13.3409 9.62535 13.3849 8.42061C13.3739 8.30802 13.3739 8.21794 13.3629 8.12787ZM10.6364 5.40312C11.472 5.77468 12.0876 6.48401 12.3515 7.35098C11.472 7.47483 10.6035 7.6212 9.73494 7.79009C9.53705 7.23838 9.33916 6.69794 9.13027 6.15749C9.02033 5.85349 8.8994 5.56075 8.77847 5.25675C9.39413 5.11038 10.0428 5.1329 10.6364 5.40312ZM3.33649 11.1116C3.98513 10.5261 4.78768 10.1208 5.61223 9.81676C5.64521 9.98565 5.6672 10.1658 5.71117 10.3347C5.86509 11.0891 6.06298 11.8209 6.30484 12.5528C4.9306 12.8117 3.53438 12.9919 2.13815 13.1495C2.33604 12.3614 2.74282 11.652 3.33649 11.1116ZM4.51284 18.2387C3.14959 17.6645 2.20412 16.4034 2.00623 14.9172C1.97325 14.6357 1.96225 14.3542 1.97325 14.0728C3.51239 13.8926 5.06253 13.7012 6.57969 13.4197C6.77758 13.9714 6.98646 14.5119 7.19535 15.0523C7.55815 15.9868 7.94293 16.8988 8.32772 17.8221C7.20634 18.554 5.76614 18.7679 4.51284 18.2387ZM10.2187 14.343C10.1747 15.4351 9.76792 16.4597 9.03133 17.2254C8.47064 15.908 7.93194 14.5794 7.4592 13.2283C7.36026 12.9468 7.26131 12.6541 7.17336 12.3726C7.08541 12.1136 7.00845 11.8547 6.93149 11.5845C6.7446 10.9427 6.5577 10.2446 6.45876 9.53528C6.41478 9.22002 6.39279 8.91602 6.39279 8.60076C6.39279 7.51987 6.70062 6.51779 7.65709 5.7972C7.75604 5.71838 7.86598 5.65083 7.98691 5.58327C8.29474 6.37142 8.59157 7.17083 8.86642 7.97024C8.96537 8.25172 9.06431 8.54446 9.15226 8.82594C9.28419 9.22002 9.40512 9.62535 9.51506 10.0194C9.65798 10.5261 9.8009 11.044 9.92183 11.5732C9.9878 11.8659 10.0428 12.1699 10.0977 12.4739C10.1857 13.0932 10.2407 13.7125 10.2187 14.343ZM11.461 10.6725C11.2411 10.8751 10.9992 11.044 10.7354 11.1904C10.5375 10.3347 10.2956 9.49024 10.0208 8.64579C10.8343 8.48816 11.6589 8.35305 12.4834 8.24046C12.4944 9.15246 12.1316 10.0645 11.461 10.6725Z"
      fill="#4B4B4B"
    />
    <path
      d="M18.519 17.293C17.3977 17.293 16.5181 17.0791 15.7596 16.4486C15.5837 16.3022 15.5837 16.0432 15.7376 15.8856L16.2653 15.3452C16.3972 15.21 16.6061 15.1988 16.76 15.3114C17.2547 15.6829 17.8704 15.818 18.53 15.818C19.4975 15.818 20.0142 15.4465 20.0142 14.7597C20.0142 14.4557 19.9373 14.208 19.7504 14.0391C19.5854 13.8815 19.3986 13.8026 19.0138 13.7351L18.0023 13.5887C17.2877 13.4761 16.76 13.2509 16.3752 12.8794C15.9794 12.474 15.7706 11.9111 15.7706 11.1905C15.7706 9.65923 16.8809 8.5896 18.6839 8.5896C19.6734 8.5896 20.421 8.80353 21.0696 9.31019C21.2455 9.4453 21.2565 9.72679 21.1026 9.88442L20.5969 10.4023C20.465 10.5375 20.2671 10.5487 20.1132 10.4361C19.6404 10.0983 19.1127 10.0533 18.64 10.0533C17.7715 10.0533 17.3427 10.5487 17.3427 11.1342C17.3427 11.3481 17.4087 11.5846 17.5846 11.7535C17.7495 11.9111 18.0243 12.0462 18.3651 12.0912L19.3546 12.2376C20.1241 12.3502 20.5969 12.5641 20.9487 12.9019C21.3994 13.341 21.5973 13.9603 21.5973 14.7259C21.6193 16.3472 20.2671 17.293 18.519 17.293Z"
      fill="#4B4B4B"
    />
    <path
      d="M30.0076 17.2143H29.2161C29.0512 17.2143 28.9083 17.1017 28.8533 16.9441L27.7539 13.2285C27.644 12.8682 27.1382 12.8682 27.0283 13.2285L25.9289 16.9441C25.8849 17.1017 25.731 17.2143 25.5661 17.2143H24.7746C24.5987 17.2143 24.4557 17.1017 24.4118 16.9328L22.3779 9.13014C22.3119 8.88244 22.4988 8.646 22.7407 8.646H23.6642C23.8401 8.646 23.994 8.76985 24.027 8.93874L24.9175 12.6543C25.0054 13.0371 25.5331 13.0484 25.6431 12.6656L26.6985 8.92748C26.7425 8.75859 26.8964 8.646 27.0613 8.646H27.7209C27.8858 8.646 28.0397 8.75859 28.0837 8.92748L29.1391 12.6768C29.2491 13.0596 29.7768 13.0484 29.8647 12.6656L30.7662 8.95C30.8102 8.78111 30.9641 8.65726 31.129 8.65726H32.0525C32.3054 8.65726 32.4813 8.8937 32.4153 9.1414L30.3704 16.9441C30.3265 17.1017 30.1836 17.2143 30.0076 17.2143Z"
      fill="#4B4B4B"
    />
    <path
      d="M38.0769 16.9551L37.7581 15.9643C37.7031 15.8067 37.5602 15.7053 37.3953 15.7053H34.9656C34.8007 15.7053 34.6578 15.8067 34.6138 15.9643L34.284 16.9551C34.229 17.1128 34.0861 17.2141 33.9322 17.2141H33.0197C32.7559 17.2141 32.5799 16.9439 32.6679 16.6962L35.4384 8.89349C35.4933 8.73586 35.6363 8.63452 35.7902 8.63452H36.5487C36.7027 8.63452 36.8456 8.73586 36.9006 8.89349L39.682 16.6962C39.77 16.9439 39.5941 17.2141 39.3302 17.2141H38.4397C38.2748 17.2141 38.1319 17.1128 38.0769 16.9551ZM35.8561 12.2375L35.3284 13.78C35.2405 14.0277 35.4274 14.2979 35.6802 14.2979H36.7027C36.9555 14.2979 37.1424 14.039 37.0655 13.7913L36.5597 12.2487C36.4498 11.8997 35.9661 11.8885 35.8561 12.2375Z"
      fill="#4B4B4B"
    />
    <path
      d="M44.1568 13.9941H42.9145C42.7056 13.9941 42.5407 14.163 42.5407 14.377V16.8315C42.5407 17.0454 42.3758 17.2143 42.1669 17.2143H41.2874C41.0785 17.2143 40.9136 17.0454 40.9136 16.8315V9.02881C40.9136 8.81488 41.0785 8.646 41.2874 8.646H44.1568C45.8828 8.646 46.9162 9.862 46.9162 11.3144C46.9162 12.7781 45.8828 13.9941 44.1568 13.9941ZM44.0688 10.1322H42.9145C42.7056 10.1322 42.5407 10.3011 42.5407 10.515V12.0913C42.5407 12.3053 42.7056 12.4741 42.9145 12.4741H44.0688C44.8054 12.4741 45.2782 12.0013 45.2782 11.3032C45.2782 10.6164 44.8054 10.1322 44.0688 10.1322Z"
      fill="#4B4B4B"
    />
  </svg>
)

const icon_checked = (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginLeft: 4 }}
  >
    <path
      d="M14.8571 5.60797L6.8571 13.608L3.19043 9.9413L4.13043 9.0013L6.8571 11.7213L13.9171 4.66797L14.8571 5.60797Z"
      fill="#00821E"
    />
  </svg>
)

export default Template
